module.exports = __webpack_public_path__ + "img/pic-paging-service1-2.0c4e3580.jpg";